module.exports = __webpack_public_path__ + "media/images/savingError-c1632be798e3f67efed8566fc1c0ae84.svg";